var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo500 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 18,
    fill: "none",
    viewBox: "0 0 54 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.905.843c-2.145-.535-4.203 2.83-5.326 7.335-1.122 4.506-.884 8.444 1.261 8.98 2.145.534 4.203-2.831 5.325-7.336 1.123-4.506.884-8.444-1.26-8.98M34.643 9c-.25 4.97-4.124 9-9.224 9s-8.568-4.03-8.317-9 4.124-9 9.224-9 8.568 4.03 8.317 9M46.499.843c-2.144-.535-4.203 2.83-5.325 7.335-1.123 4.506-.884 8.444 1.26 8.98 2.145.534 4.203-2.831 5.326-7.336s.884-8.444-1.26-8.98M53.237 9c-.25 4.97-4.124 9-9.224 9s-8.567-4.03-8.317-9 4.125-9 9.224-9 8.568 4.03 8.317 9m-37.009 2.793c-.14 3.992-3.882 6.157-7.735 6.157-3.264 0-6.312-1.747-7.743-2.81l1.61-4.475.096.035c2.647 3.959 4.896 6.686 7.247 6.474 1.555-.14 2.48-1.09 2.545-2.97.09-2.615-1.904-5.857-9.41-4.519l-.111-.04L6.105.25h11.324l-1.52 4.227H5.299l-1 2.782c5.995-3.081 12.081.17 11.929 4.534"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.75 0h52.5v18H.75z"
  })))));
};
export default SvgLogo500;